import script from "./LogoView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LogoView.vue?vue&type=script&setup=true&lang=ts"

import "./LogoView.vue?vue&type=style&index=0&id=341b006a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-341b006a"]])

export default __exports__